import React, { Component } from "react";
import "../App.css";
import { Well } from "react-bootstrap";

class StatusBox extends Component {
  render() {
    const { type, loading, color, title, info, id } = this.props;

    return (
      <Well className="some">
        <div className="summary_some">
          <div className="summary_title">{title}</div>

          {loading ? (
            <div className="summary_loading">
              <span style={{ textTransform: "none" }}>Loading...</span>
            </div>
          ) : (
            <div className="summary_info">
              {type === "TRADEMARKS" ? (
                <div>
                  <div
                    className="summary_info_trademarks_1"
                    style={{ color: color }}
                  >
                    <span>{info[0]}</span>
                  </div>
                  <div
                    className="summary_info_trademarks_2"
                    style={{ color: color }}
                  >
                    {info[1]}
                  </div>
                </div>
              ) : (
                <span style={{ color: color }}>{info[0]}</span>
              )}
            </div>
          )}

          <div className="summary_info_lower">
            {!loading &&
              (type === "TRADEMARKS" ? (
                <div>
                  <div
                    className="summary_info_trademarks_3"
                    style={{ color: color }}
                  >
                    <span>{info[2]}</span>
                  </div>
                  <div
                    className="summary_info_trademarks_4"
                    style={{ color: color }}
                  >
                    {info[3]}
                  </div>
                </div>
              ) : (
                <span style={{ color: color }}>{info[1]}</span>
              ))}
          </div>

          <div className="view">
            <button
              className="view_button"
              onClick={() => {
                if (!loading && id) {
                  document.getElementById(id).scrollIntoView();
                }
              }}
            >
              {!loading && "VIEW"}
            </button>
          </div>
        </div>
      </Well>
    );
  }
}

export default StatusBox;



// WEBPACK FOOTER //
// ./client/src/components/StatusBox.js